import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export default (theme: ApplicationMuiTheme) => ({
    content: {
        maxWidth: '500px',
        backgroundColor: theme?.app?.applicationColors.enumColors.offWhite || '#f1f1f7',
        padding: '2rem',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.greyLighter || '#CCC'}`,
        borderRadius: '5px',
        boxShadow: `0 2px 4px 0 ${theme?.app?.applicationColors.enumColors.greyLighter || 'rgba(0, 0, 0, 0.4)'}`
    },
    headerText: { margin: 0 },
    buttons: {
        display: 'flex' as const,
        justifyContent: 'center' as const,
        flex: '1 0 auto'
    }
});